import Actions from '.';
import { get, post, patch, deleteCall, put } from '../../../utils/api';
import { API_ERROR_MESSAGE, DEFAULT_RECORD_LIMIT } from '../../../constants';

const getOffer = () => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`offers/list`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                success: true,
                list: (data.response || {}).offers || [],
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                data: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            data: [],
        }));
    }
});

const getOfferProducts = () => (async (dispatch, getState) => {
    const { offers: { offerId } } = getState();
    let url = `products?limit=${DEFAULT_RECORD_LIMIT}&offerId=${offerId}`

    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(url);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                offerProducts: (data.response || {}).products || [],
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                data: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            data: [],
        }));
    }
});

const addOffer = values => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));

    const { offerDescription, imageDescription, offerType, discountBy, amount, percentage, file, products,
        quantity, unitType, squareFeet, pieces, maximumAmount } = values
    const body = new FormData();
    body.append('offerDescription', offerDescription);
    body.append('imageDescription', imageDescription);
    body.append('discountBy', discountBy);
    body.append('amount', amount);
    body.append('percentage', percentage);
    body.append('file', file);
    body.append('offerType', offerType);
    body.append('products', products);
    body.append('quantity', quantity)
    body.append('unitType', unitType)
    body.append('squareFeet', squareFeet)
    body.append('pieces', pieces)
    body.append('maximumAmount', maximumAmount)


    const data = await post(`offers/`, body, { contentType: 'multipart/form-data' });
    try {
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                success: true,
                showOfferModal: false,
            }));
            dispatch(getOffer());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }

})

const editOffer = values => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));

    const { offerDescription, imageDescription, offerType, discountBy, amount, percentage, file, products, quantity,
        unitType, squareFeet, pieces, maximumAmount, id } = values
    const body = new FormData();
    body.append('offerDescription', offerDescription);
    body.append('imageDescription', imageDescription);
    body.append('discountBy', discountBy);
    body.append('amount', amount);
    body.append('percentage', percentage);
    body.append('file', file);
    body.append('offerType', offerType);
    body.append('products', products);
    body.append('quantity', quantity)
    body.append('unitType', unitType)
    body.append('squareFeet', squareFeet)
    body.append('pieces', pieces)
    body.append('maximumAmount', maximumAmount)


    const data = await put(`offers/${id}`, body, { contentType: 'multipart/form-data' });
    try {
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                showOfferModal: false,
            }));
            dispatch(getOffer());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }

})

const deleteOffer = id => (async (dispatch) => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await deleteCall(`offers/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                success: true,
            }));
            dispatch(getOffer());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                data: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            data: [],
        }));
    }
});

const clearOfferProducts = () => (async (dispatch) => {
    dispatch(Actions.updateProperties({
        offerProducts: [],
    }));

});

const addOfferProducts = () => (async (dispatch) => {
    dispatch(Actions.updateProperty('loading', true));
    dispatch(Actions.updateProperties({
        loading: false,
        error: "Product added sucessfully",
    }));


});


export default {
    addOffer,
    editOffer,
    getOffer,
    getOfferProducts,
    clearOfferProducts,
    addOfferProducts,
    deleteOffer
}